/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect } from 'react';

import {
    useIntl,
    FormattedMessage,
} from "react-intl";

import defaultLabels from '../store/models/language/en.json';
import { useAppStore } from '../store/models/app';

function translateWithIntl (intl, label) {
    const translated = intl.formatMessage({ id: label});
    if (translated.indexOf('sync.') !== -1 ) {
        return defaultLabels[label];
    }

    return translated.trim();
}

function translateWithDynamicValues (intl, label, params) {
    const translated = intl.formatMessage({ id: label});

    return (
        <FormattedMessage
            id={label}
            defaultMessage={translated}
            values={params}
        />
    );
}

function translateHTMLValues (intl, label) {
    const translated = intl.formatMessage({ id: label});

    if (translated.indexOf('sync.') !== -1 ) {
        return;
    }

    return (
        <FormattedMessage
            id={label}
            defaultMessage="{html}"
            values={{
                html:  (<span dangerouslySetInnerHTML={{ __html: translated }} />)
            }}
        />
    );
}
  
function useTranslator () {
    const intl = useIntl();
    const appStore = useAppStore();

    useEffect(() => {
        appStore.translate = translate;
    }, []);

    function translate (label){
        const translation =  translateWithIntl(intl, label);

        return translation;
    };

    function translateWithValues (label, values) {
        return translateWithDynamicValues(
            intl,
            label,
            values,
        );
    }

    function translateHTMLMessage (label) {
        return translateHTMLValues(
            intl,
            label,
        );
    }   
    
    function translateWithTags (label, values) {
        return (
            <FormattedMessage
                id={label}
                defaultMessage={defaultLabels[label]}
                values={values}
            />
        );
    }

    return {
        translate,
        translateWithValues,
        translateHTMLMessage,
        translateWithTags,
    };
}


export default useTranslator;
